import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// eslint-disable-next-line no-restricted-imports
import App from "./App";

const rootElement = document.getElementById("reco-root");
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} else {
  // eslint-disable-next-line no-console
  console.error("Root element not found");
}
